import {BrowserRouter as Router} from "react-router-dom";
import {AppRouterHistory} from "./AppRouterHistory";

export const AppRouter = (): JSX.Element => {
  return (
    <Router>
      <AppRouterHistory/>
    </Router>
  );
};
